import React, { useState } from 'react'
import { ReactComponent as CookiesIcon } from '../../assets/icons/cookies.svg'
import Button from '../Button/Button'
import { Color } from '../../utils/constants'
import Modal from '../Modal'
import CookieModal from './CookieModal'
import CK from 'js-cookie'

interface CookiesProps {
  setShowCookies: (show: boolean) => void
}

const Cookies = ({ setShowCookies }: CookiesProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [cookieForm, setCookieForm] = useState<Record<string, { on: boolean; editable: boolean }>>({
        necessary: {
            on: true,
            editable: false,
        },
        marketing: {
            on: false,
            editable: true,
        },
        statistics: {
            on: false,
            editable: true,
        },
        analytics: {
            on: false,
            editable: true,
        },
    })
    const submit = () => {
        const values = Object.entries(cookieForm).map(([key, value]) => {
            return [key, value.on]
        })
        const value: Record<string, boolean> = {}
        values.forEach((val) => {
            const [key, on] = val
            // @ts-ignore
            value[key] = on
        })
        CK.set('cookies', JSON.stringify(value))
        setShowCookies(false)
    }

    return (
        <div className='w-screen h-screen fixed pointer-events-none top-0 z-50'>
            <div className='p-3 md:p-6 absolute bottom-0 right-0 w-full'>
                <div
                    className='ml-auto w-full md:max-w-[670px] h-auto bg-black gap-4 rounded-full pointer-events-auto flex items-center justify-center p-3'
                    style={{ boxShadow: '0 4px 40px rgba(0, 0, 0, 0.25)' }}
                >
                    <CookiesIcon className='shrink-0' style={{ width: '18px', height: '18px' }} />
                    <div className='flex items-center gap-4 text-white text-xs'>
                        <span className=''>This website uses cookies.</span>
                        <Button
                            buttonColor={Color.WHITE}
                            isInverted
                            innerClasses='p-3 group-hover:p-2.5 group-hover:m-0.5'
                            onClick={() => setIsModalOpen(true)}
                        >
                            <h6>Select optional cookies</h6>
                        </Button>
                    </div>
                    <Button
                        buttonColor={Color.WHITE}
                        isInverted
                        innerClasses='p-3 group-hover:p-2.5 group-hover:m-0.5'
                        onClick={submit}
                    >
                        <h6>Accept all cookies</h6>
                    </Button>
                </div>
            </div>
            {isModalOpen && (
                <Modal close={() => setIsModalOpen(false)}>
                    <CookieModal
                        onClose={() => setIsModalOpen(false)}
                        cookieForm={cookieForm}
                        setCookieForm={setCookieForm}
                        submit={submit}
                    />
                </Modal>
            )}
        </div>
    )
}

export default Cookies
